// COUNTDOWN
const saleStart = new Date('2026-06-10T00:00:00+08:00').getTime();
const saleEnd = new Date('2026-06-30T23:59:59+08:00').getTime();
function updateCountdown(){
  const now = Date.now();
  let target = saleStart, label = 'starts in';
  if(now >= saleStart && now < saleEnd){ target = saleEnd; label = 'ends in'; }
  else if(now >= saleEnd){
    document.getElementById('cdMini').textContent = 'Sale has ended';
    document.querySelectorAll('#cdDays,#cdHours,#cdMins,#cdSecs').forEach(e=>e.textContent='00');
    return;
  }
  const d = Math.max(0, target - now);
  const days = Math.floor(d/86400000);
  const hours = Math.floor(d%86400000/3600000);
  const mins = Math.floor(d%3600000/60000);
  const secs = Math.floor(d%60000/1000);
  document.getElementById('cdDays').textContent = String(days).padStart(2,'0');
  document.getElementById('cdHours').textContent = String(hours).padStart(2,'0');
  document.getElementById('cdMins').textContent = String(mins).padStart(2,'0');
  document.getElementById('cdSecs').textContent = String(secs).padStart(2,'0');
  //document.getElementById('cdMini').textContent = 'Sale ${label} ${days}d ${hours}h ${mins}m';
}
updateCountdown();
setInterval(updateCountdown, 1000);

// TYPING GAME
const passages = [
  "There's a moment when a keyboard sounds right and you just know. Not loud, not quiet, just settled. The kind of thock that makes you stop typing for a second, hit the key again, and smile.",
  "It started as a group buy in 2019. A few people on a forum decided the keyboards they wanted didn't exist yet, so they built one together. That's still how the good ones get made.",
  "Foam density, plate material, gasket hardness, switch lube, stabilizer tuning. Each one shifts the sound a little. Stack the right combination together and a keyboard stops being hardware and starts being an instrument.",
  "Some people want a thocky sixty percent for late nights. Others want aluminum that rings when you press it, or magnetic switches fast enough to win a round. There is no single right answer, only the one that sounds right to you."
];

let currentPassage = '', typeStart = 0, typeTimer = null, gameActive = false;
const TIME_LIMIT = 60;
let timeLeft = TIME_LIMIT, currentStreak = 0, bestStreak = 0;
let keystrokes = [], backspaceCount = 0, focusLost = false;

function loadPassage(){
  currentPassage = passages[Math.floor(Math.random()*passages.length)];
  const display = document.getElementById('typeDisplay');
  const words = currentPassage.split(/(\s+)/);
  let charIdx = 0, html = '';
  words.forEach(word => {
    if(/^\s+$/.test(word)){for(const ch of word){html += `<span class="char" data-i="${charIdx}">${ch}</span>`; charIdx++;}}
    else {html += `<span class="word">`; for(const ch of word){html += `<span class="char" data-i="${charIdx}">${ch}</span>`; charIdx++;} html += `</span>`;}
  });
  display.innerHTML = html;
  const firstChar = display.querySelector('.char');
  if(firstChar) firstChar.classList.add('current');
}

function resetGame(){
  const input = document.getElementById('typeInput');
  input.value=''; input.disabled=false;
  document.getElementById('liveWpm').textContent='0';
  document.getElementById('liveAcc').textContent='100%';
  document.getElementById('liveTime').textContent=TIME_LIMIT;
  document.getElementById('liveStreak').textContent='0';
  document.getElementById('resultPanel').classList.remove('show');
  clearInterval(typeTimer);
  typeStart=0; gameActive=false; timeLeft=TIME_LIMIT;
  currentStreak=0; bestStreak=0;
  keystrokes=[]; backspaceCount=0; focusLost=false;
  loadPassage();
}

function startTimer(){
  typeStart = Date.now();
  gameActive = true;
  typeTimer = setInterval(()=>{
    timeLeft = TIME_LIMIT - Math.floor((Date.now()-typeStart)/1000);
    document.getElementById('liveTime').textContent = Math.max(0,timeLeft);
    if(timeLeft<=0) endGame();
  },200);
}

function calcStats(typed){
  let correct = 0;
  for(let i=0;i<typed.length;i++){if(typed[i]===currentPassage[i]) correct++;}
  const minutes = (Date.now()-typeStart)/60000;
  const wpm = minutes>0 ? Math.round((correct/5)/minutes) : 0;
  const acc = typed.length>0 ? Math.round((correct/typed.length)*100) : 100;
  return {wpm, acc};
}

function endGame(){
  clearInterval(typeTimer);
  gameActive = false;
  document.getElementById('typeInput').disabled = true;
  document.getElementById('resultPanel').classList.add('show');
  document.getElementById('emailGate').style.display = 'block';
  document.getElementById('codeReveal').style.display = 'none';
  document.getElementById('claimEmail').value = '';
  document.getElementById('claimError').style.display = 'none';
  setTimeout(()=>document.getElementById('claimEmail').focus(), 400);
}

const CODE_POOL = ['EPO-TYPE-5','EPO-TYPE-5','EPO-TYPE-5','EPO-TYPE-5','EPO-TYPE-5'];
const STORAGE_KEY = 'epomaker_sprint_2026';
function loadClaimState(){try{return JSON.parse(localStorage.getItem(STORAGE_KEY)||'{}');}catch{return{};}}
function saveClaimState(s){try{localStorage.setItem(STORAGE_KEY, JSON.stringify(s));}catch{}}

document.getElementById('claimBtn').addEventListener('click', () => {
  const email = document.getElementById('claimEmail').value.trim().toLowerCase();
  const errEl = document.getElementById('claimError');
  errEl.style.display = 'none';
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
    errEl.textContent = 'Please enter a valid email address.';
    errEl.style.display = 'block';
    return;
  }
  const blocked = ['mailinator.com','tempmail.com','10minutemail.com','guerrillamail.com','throwaway.email','yopmail.com'];
  if(blocked.includes(email.split('@')[1])){
    errEl.textContent = 'Disposable email addresses are not accepted.';
    errEl.style.display = 'block';
    return;
  }
  const state = loadClaimState();
  if(state.claimedEmail === email){
    errEl.textContent = `This email already claimed a $5 code: ${state.claimedCode}`;
    errEl.style.display = 'block';
    return;
  }
  const code = CODE_POOL[Math.floor(Math.random()*CODE_POOL.length)];
  saveClaimState({claimedEmail:email, claimedCode:code, claimedAt:Date.now()});
  document.getElementById('emailGate').style.display = 'none';
  document.getElementById('codeReveal').style.display = 'block';
  document.getElementById('resultCodeText').textContent = code;
});

function copyCode(){
  const code = document.getElementById('resultCodeText').textContent;
  if(!code || code === 'CODE') return;
  navigator.clipboard.writeText(code).then(()=>{
    const el = document.getElementById('resultCode');
    el.style.background = 'var(--cyan)'; el.style.color = 'var(--bg)';
    setTimeout(()=>{el.style.background=''; el.style.color='';}, 800);
  }).catch(()=>{});
}

const typeInput = document.getElementById('typeInput');
typeInput.addEventListener('paste', e=>{e.preventDefault();});
typeInput.addEventListener('drop', e=>e.preventDefault());
typeInput.addEventListener('input', (e)=>{
  const typed = e.target.value;
  if(!gameActive && typed.length === 1) startTimer();
  if(!gameActive) return;
  const chars = document.querySelectorAll('#typeDisplay .char');
  chars.forEach((c,i)=>{
    c.className = 'char';
    if(i < typed.length){
      if(typed[i] === currentPassage[i]){c.classList.add('correct'); currentStreak = Math.max(currentStreak, i+1);}
      else c.classList.add('wrong');
    }
    if(i === typed.length) c.classList.add('current');
  });
  bestStreak = Math.max(bestStreak, currentStreak);
  document.getElementById('liveStreak').textContent = bestStreak;
  const {wpm, acc} = calcStats(typed);
  document.getElementById('liveWpm').textContent = wpm;
  document.getElementById('liveAcc').textContent = acc + '%';
  if(typed.length >= currentPassage.length) endGame();
});
document.getElementById('restartBtn').addEventListener('click', resetGame);
document.getElementById('newTextBtn').addEventListener('click', resetGame);
loadPassage();

// PLACEHOLDER IMAGES
const PRODUCT_IMG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'><rect width='800' height='500' fill='%2316161c'/><g stroke='%23393944' stroke-width='1.5' fill='none' opacity='.5'><rect x='340' y='210' width='120' height='80' rx='4'/><circle cx='420' cy='235' r='8'/><path d='M340 260 L380 222 L440 290' stroke-linejoin='round'/></g></svg>");
const BUNDLE_IMG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'><rect width='800' height='500' fill='%2316161c'/><g stroke='%23393944' stroke-width='1.5' fill='none' opacity='.5'><rect x='280' y='200' width='130' height='90' rx='5'/><circle cx='480' cy='245' r='55'/><circle cx='480' cy='245' r='35'/></g></svg>");

// DEAL DATA
const dealsByTier = {
  '10':[
    {pct:'-10%',name:'F75 / F75 MAX',cat:'Compact Keyboard'},
    {pct:'-10%',name:'AK820 PRO',cat:'Wireless Board'},
    {pct:'-10%',name:'Galaxy 65 / 68',cat:'Magnetic Board'},
    {pct:'-10%',name:'QK81',cat:'Pro Series'},
    {pct:'-10%',name:'EA75',cat:'Aluminum'},
    {pct:'-10%',name:'F65 PRO',cat:'New Arrival'},
    {pct:'-10%',name:'G84',cat:'Hot-Swap'},
    {pct:'-10%',name:'TH108',cat:'Full-Size'},
  ],
  '30':[
    {pct:'-30%',name:'RT100',cat:'Display Board'},
    {pct:'-30%',name:'KiiBOOM Phantom 81',cat:'Acrylic'},
    {pct:'-30%',name:'KiiBOOM Phantom 980',cat:'Full Acrylic'},
    {pct:'-30%',name:'F65',cat:'Compact'},
    {pct:'-30%',name:'Carbon60',cat:'Carbon Fiber'},
    {pct:'-30%',name:'Cream Bunny Keycap',cat:'Keycap Set'},
    {pct:'-30%',name:'Meow Sushi Keycap',cat:'Keycap Set'},
    {pct:'-30%',name:'KiiBOOM Phantom 21',cat:'Mini'},
  ],
  '50':[
    {pct:'-50%',name:'RT100 (FR/JP/ES)',cat:'Localized Layout'},
    {pct:'-50%',name:'RT100 Cable',cat:'Accessory'},
    {pct:'-50%',name:'Hi75',cat:'Compact'},
    {pct:'-50%',name:'KiiBOOM Moonshadow 81',cat:'Discontinued'},
    {pct:'-50%',name:'LEOBOG Switches',cat:'Switch Set'},
    {pct:'-50%',name:'RT100 Mini Display',cat:'Mod Part'},
  ],
  '60':[
    {pct:'-60%',name:'Brick87',cat:'Vintage'},
    {pct:'-60%',name:'AJ139 PRO',cat:'Macro Pad'},
    {pct:'-60%',name:'AJ199',cat:'Macro Pad'},
    {pct:'-60%',name:'Wisteria V2 Switch',cat:'Switch Set'},
    {pct:'-60%',name:'PUFF Cable',cat:'Cable'},
    {pct:'-60%',name:'MIX SE Cable',cat:'Cable'},
    {pct:'-60%',name:'TTC Switch Set',cat:'Switch Set'},
    {pct:'-60%',name:'Vial Adapter',cat:'Accessory'},
  ],
  '70':[
    {pct:'-70%',name:'Dynatab 75X / 75',cat:'Outgoing Model'},
    {pct:'-70%',name:'SK61',cat:'Entry Level'},
    {pct:'-70%',name:'Wisteria Linear Switch',cat:'Switch Set'},
    {pct:'-70%',name:'MIX Cable',cat:'Cable'},
    {pct:'-70%',name:'Bluebird Switch Set',cat:'Switch Set'},
    {pct:'-70%',name:'EPOMAKER Stabilizer',cat:'Stab Set'},
    {pct:'-70%',name:'Keychain',cat:'Merch'},
    {pct:'-70%',name:'Temple Keycaps',cat:'Keycap Set'},
  ]
};
function renderDeals(tier){
  const grid = document.getElementById('dealGrid');
  grid.innerHTML = (dealsByTier[tier]||[]).map(d=>`
    <div class="deal-card">
      <div class="deal-img-wrap">
        <div class="deal-pct-badge">${d.pct}</div>
        <img class="deal-img" src="${PRODUCT_IMG}" alt="${d.name}" loading="lazy" />
      </div>
      <div class="deal-meta">
        <div class="deal-name">${d.name}</div>
        <div class="deal-cat">${d.cat}</div>
      </div>
    </div>
  `).join('');
}
document.getElementById('dealTabs').addEventListener('click', e=>{
  if(!e.target.classList.contains('deal-tab')) return;
  document.querySelectorAll('.deal-tab').forEach(t=>t.classList.remove('active'));
  e.target.classList.add('active');
  renderDeals(e.target.dataset.tier);
});
renderDeals('10');

// BUNDLES
const bundles = [
  {letter:'BUNDLE A', name:'HE68 Lite + Click Lite Mouse', subtitle:'Affordable office combo for everyday productivity.', items:['HE68 Lite Keyboard','Click Lite Mouse']},
  {letter:'BUNDLE B', name:'HE80 + Click Lite Mouse', subtitle:'Entry-level full-feature setup, ready out of the box.', items:['HE80 Keyboard','Click Lite Mouse']},
  {letter:'BUNDLE C', name:'TH108 + AegisSil Keycaps', subtitle:'Full-size board with a premium aesthetic upgrade.', items:['TH108 Keyboard','AegisSil Keycaps Set']},
  {letter:'BUNDLE D', name:'TH108 PRO + CarbonX Mouse', subtitle:'Performance-focused setup for serious office and play.', items:['TH108 PRO Keyboard','CarbonX Mouse']},
  {letter:'BUNDLE E', name:'Galaxy100 QMK/VIA + Nude Rosa Silent', subtitle:'Hot-swap flagship for the modding enthusiasts.', items:['Galaxy100 QMK/VIA','Nude Rosa Silent Switches']},
  {letter:'BUNDLE F', name:'AULA F99 PRO + Lavender Keycaps', subtitle:'Pink &amp; purple themed set for the aesthetics crowd.', items:['AULA F99 PRO','Lavender Keycaps Set']},
];
document.getElementById('bundleGrid').innerHTML = bundles.map(b=>`
  <div class="bundle-card">
    <div class="bundle-img-wrap">
      <div class="bundle-discount-badge">-20% OFF</div>
      <img class="bundle-img" src="${BUNDLE_IMG}" alt="${b.name}" loading="lazy" />
    </div>
    <div class="bundle-body">
      <span class="bundle-letter">${b.letter}</span>
      <div class="bundle-name">${b.name}</div>
      <p class="bundle-subtitle">${b.subtitle}</p>
      <div class="bundle-items">
        <span class="bundle-pill">${b.items[0]}</span>
        <span class="bundle-plus">+</span>
        <span class="bundle-pill">${b.items[1]}</span>
      </div>
    </div>
  </div>
`).join('');